import { useMemo } from "react";
import "./style/shotsOnGoalTop5.scss";
import { Divider } from "antd";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import Image from "../../../../shared/components/Image";

const Bar = ({ rating, maxRating }) => {
  const width = 2.1 * (rating * 100) / maxRating;
  return (
    <div className="bar-container">
      <div className="bar" style={{ width: `${width}px` }}></div>
      <span className="rating">Ø {rating}</span>
    </div>
  );
};

const PressingTop5 = ({ teamRanking, competitionId }) => {
  const { t } = useTranslation();
  const processedData = useMemo(() => {
    const data = teamRanking.map((entry) => {
      const scoringStat = entry.additionalStats.find(
        (stat) => stat.type === "total scoring att"
      );
      const totalGames = entry.calcStats.find(
        (stat) => stat.type === "total games"
      )?.value;

      const rating = scoringStat && totalGames
        ? _.round(scoringStat.value / totalGames, 1)
        : 0;

      return {
        id: entry.id,
        name: entry.name,
        rank: entry.rank,
        rating: parseFloat(rating.toFixed(1)),
      };
    });
    return data.sort((a, b) => b.rating - a.rating);
  }, [teamRanking]);

  const maxRating = useMemo(() => {
    return Math.max(...processedData.map((item) => parseFloat(item.rating)));
  }, [processedData]);

  return (
    <div className="top-shorts-container">
      <div className="top-shorts-header">
        {/* <img
          src={`http://localhost:3001/images/dynamic/soccer/competition/6by3h89i2eykc341oz7lv1ddd.svg`}
          alt={`team`}
          className="logo"
        /> */}
        <Image
          src={`/images/dynamic/soccer/competition/${competitionId}.svg`}
          className="logo"
        />
        <span className="title">{t("Shots per 90 min.")}</span>
      </div>
      <Divider type="horizontal" className="top-shorts-divider" />

      <div className="graph">
        {processedData.map(({ id, rank, name, rating }, index) => (
          <div key={id} className="team-row">
            <div className="team-info">
              <span className="rank">{index + 1}.</span>
              <Image
                className="logo"
                src={`/images/dynamic/soccer/team/${id}.png`}
                alt={name}
                width={24}
                height={24}
              />
            </div>
            <Bar rating={parseFloat(rating)} maxRating={maxRating} />
          </div>
        ))}
      </div>

      <Divider type="horizontal" className="top-shorts-divider" />
    </div>
  );
};

export default PressingTop5;
